export const openProfileTab = (gh, li, lc, cc, hr, onObject) => {
  if (onObject.object.uuid === gh.current.uuid)
    window.open("https://dev.to/cristiancezarmoises", "new");
  if (onObject.object.uuid === li.current.uuid)
    window.open("https://linkedin.com/in/cristiancezarmoises", "new");
  if (onObject.object.uuid === lc.current.uuid)
    window.open("https://defendtheweb.net/profile/lordhack", "new");
  if (onObject.object.uuid === cc.current.uuid)
    window.open("https://tryhackme.com/p/cristiancmoises", "new");
  if (onObject.object.uuid === hr.current.uuid)
    window.open("https://www.github.com/cristiancmoises/", "new");
};

export const openProjectTab = (sf, iic, chat, museum, ttt, onObject) => {
  if (onObject.object.uuid === sf.current.uuid)
    window.open("https://www.youtube.com/watch?v=byBAkdH73B8&t=10s", "new");
  if (onObject.object.uuid === iic.current.uuid)
    window.open("https://fasteros.vercel.app", "new");
  if (onObject.object.uuid === chat.current.uuid)
    window.open("https://github.com/cristiancmoises/cleanall", "new");
  if (onObject.object.uuid === museum.current.uuid)
    window.open("https://ipman.vercel.app", "new");
  if (onObject.object.uuid === ttt.current.uuid)
    window.open("https://github.com/cristiancmoises/chocolate", "new");
};

export const openProjectGithub = (sf, iic, chat, museum, ttt, onObject) => {
  if (onObject.object.uuid === sf.current.uuid)
    window.open("https://github.com/cristiancmoises/securityops", "new");
  if (onObject.object.uuid === iic.current.uuid)
    window.open("https://github.com/cristiancmoises/faster-os", "new");
  if (onObject.object.uuid === chat.current.uuid)
    window.open("https://github.com/cristiancmoises/cleanall", "new");
  if (onObject.object.uuid === museum.current.uuid)
    window.open("https://github.com/cristiancmoises/", "new");
  if (onObject.object.uuid === ttt.current.uuid)
    window.open(
      "https://github.com/cristiancmoises/chocolate", "new");
};
